/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnresolvedVendorErrorCodeRemarkActionRequestDto
 */
export interface UnresolvedVendorErrorCodeRemarkActionRequestDto {
    /**
     * Audit remark for this action
     * @type {string}
     * @memberof UnresolvedVendorErrorCodeRemarkActionRequestDto
     */
    remark: string;
    /**
     * Optimistic concurrency version from the last read
     * @type {number}
     * @memberof UnresolvedVendorErrorCodeRemarkActionRequestDto
     */
    expectedVersion: number;
}

/**
 * Check if a given object implements the UnresolvedVendorErrorCodeRemarkActionRequestDto interface.
 */
export function instanceOfUnresolvedVendorErrorCodeRemarkActionRequestDto(value: object): value is UnresolvedVendorErrorCodeRemarkActionRequestDto {
    if (!('remark' in value) || value['remark'] === undefined) return false;
    if (!('expectedVersion' in value) || value['expectedVersion'] === undefined) return false;
    return true;
}

export function UnresolvedVendorErrorCodeRemarkActionRequestDtoFromJSON(json: any): UnresolvedVendorErrorCodeRemarkActionRequestDto {
    return UnresolvedVendorErrorCodeRemarkActionRequestDtoFromJSONTyped(json, false);
}

export function UnresolvedVendorErrorCodeRemarkActionRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnresolvedVendorErrorCodeRemarkActionRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'remark': json['remark'],
        'expectedVersion': json['expectedVersion'],
    };
}

export function UnresolvedVendorErrorCodeRemarkActionRequestDtoToJSON(json: any): UnresolvedVendorErrorCodeRemarkActionRequestDto {
    return UnresolvedVendorErrorCodeRemarkActionRequestDtoToJSONTyped(json, false);
}

export function UnresolvedVendorErrorCodeRemarkActionRequestDtoToJSONTyped(value?: UnresolvedVendorErrorCodeRemarkActionRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'remark': value['remark'],
        'expectedVersion': value['expectedVersion'],
    };
}

